<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <v-row>
      <v-col cols="12">
        <validation-observer
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(getHistoryListRangeDate)">
            <base-material-card
              class="pa-6"
              color="bgTankReport"
              icon="mdi-file-chart"
            >
              <template v-slot:after-heading>
                <div class="display-2 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTankReport pa-7">
                  {{ $t('parameters') }}
                </div>
              </template>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.rangeDAteTank.startDate"
                          >
                            <v-text-field
                              v-model="parameter.startDate"
                              :label="$t('fields.reportParameters.rangeDAteTank.startDate')"
                              hint="YYYY/MM/DD"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="parameter.startDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="startDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        ref="menuStartTime"
                        v-model="startTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.rangeDAteTank.startTime"
                          >
                            <v-text-field
                              v-model="startTime"
                              :label="$t('fields.reportParameters.rangeDAteTank.startTime')"
                              prepend-icon="mdi-timer"
                              readonly
                              v-bind="attrs"
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-time-picker
                          v-if="startTimeMenu"
                          v-model="startTime"
                          format="24hr"
                          full-width
                          @click:minute="$refs.menuStartTime.save(startTime)"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.rangeDAteTank.endDate"
                          >
                            <v-text-field
                              v-model="parameter.endDate"
                              :label="$t('fields.reportParameters.rangeDAteTank.endDate')"
                              hint="YYYY/MM/DD"
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-date-picker
                          v-model="parameter.endDate"
                          no-title
                          :locale="$i18n.locale"
                          @input="endDateMenu = false"
                        />
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                    >
                      <v-menu
                        ref="menuEndTime"
                        v-model="endTimeMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                            name="reportParameters.rangeDAteTank.endTime"
                          >
                            <v-text-field
                              v-model="endTime"
                              :label="$t('fields.reportParameters.rangeDAteTank.endTime')"
                              prepend-icon="mdi-timer"
                              readonly
                              v-bind="attrs"
                              :error-messages="errors"
                              v-on="on"
                            />
                          </validation-provider>
                        </template>
                        <v-time-picker
                          v-if="endTimeMenu"
                          v-model="endTime"
                          format="24hr"
                          full-width
                          @click:minute="$refs.menuEndTime.save(endTime)"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="reportParameters.rangeDAteTank.targetId"
                  >
                    <v-select
                      v-model="parameter.targetId"
                      :items="targets"
                      item-text="description"
                      item-value="id"
                      :label="$t('fields.reportParameters.rangeDAteTank.targetId')"
                      :error-messages="errors"
                      outlined
                      :loading="loadingTargets"
                      @change="getTargetDevicesByTarget"
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="reportParameters.rangeDAteTank.targetDeviceId"
                  >
                    <v-select
                      v-model="parameter.targetDeviceId"
                      :items="targetDevices"
                      item-text="description"
                      item-value="id"
                      :label="$t('fields.reportParameters.rangeDAteTank.targetDeviceId')"
                      :error-messages="errors"
                      outlined
                      :loading="loadingTargetDevices"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <div class="pa-3 text-center">
                <v-btn
                  color="success"
                  default
                  type="submit"
                  :loading="loadingTankList"
                >
                  {{ $t("show") }}
                </v-btn>
                <v-btn
                  color="secondary"
                  default
                  type="submit"
                  :loading="loadingExcel"
                  @click="downloadExcel"
                >
                  <v-icon left>
                    mdi-download
                  </v-icon>
                  {{ $t('exportToExcel') }}
                </v-btn>
              </div>
            </base-material-card>
          </form>
        </validation-observer>
      </v-col>
    </v-row>

    <base-material-card
      color="bgTankReport"
      icon="mdi-grease-pencil"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgTankReport pa-7">
          {{ $t('measurements') }}
        </div>
      </template>

      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" /> -->

      <v-data-table
        :headers="localizationHeaders"
        :items="tankList"
        :search.sync="search"
        :loading="loadingTankList"
        :server-items-length="totalTanks"
        :options.sync="options"
      >
        <template v-slot:item.registerAt="{ item }">
          {{ item.registerAt | formatLongAndSecondDate }}
        </template>
      </v-data-table>
    </base-material-card>

    <tank-graph-date :target-device-id="graphTargetDeviceId" />
  </v-container>
</template>

<script>
  import filters from '@/common/filters'
  import { exportToExcel } from '@/common/excelExport'
  import moment from 'moment'
  import TankGraphDate from '@/views/dashboard/components/tanks/TankGraphDate'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const targetsRespository = repositoryFactory.get('targets')
  const targetdDevicesRespository = repositoryFactory.get('targetdDevices')
  const tankRepository = repositoryFactory.get('tanks')

  export default {
    name: 'TankRangeDateReport',
    components: { TankGraphDate },
    mixins: [filters],
    data: () => ({
      search: null,
      targetDevices: [],
      targets: [],
      tankList: [],
      totalTanks: 0,
      parameter: {
        targetDeviceId: '',
        startDate: moment().format('YYYY-MM-DD'), // new Date().toISOString().substr(0, 10),
        endDate: moment().format('YYYY-MM-DD'),
      },
      graphTargetDeviceId: '',
      loadingTargets: false,
      loadingTargetDevices: false,
      loadingTankList: false,
      startDateMenu: false,
      startTimeMenu: false,
      endTimeMenu: false,
      endDateMenu: false,
      options: {},
      startTime: '00:00',
      endTime: '23:59',
      jsonExcelfields: {
        Fecha: 'registerAt',
        Celsius: 'celsius',
        Fahrenheit: 'fahrenheit',
      },
      loadingExcel: false,
    }),
    computed: {
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.tankReport.registerAt'),
            value: 'registerAt',
          },
          {
            text: this.$t('tables.tankReport.currentLiters'),
            value: 'currentLiters',
          },
          {
            text: this.$t('tables.tankReport.currentGallons'),
            value: 'currentGallons',
          },
        ]
      },
    },
    watch: {
      options: {
        handler () {
          this.getHistoryListRangeDate()
        },
        deep: true,
      },
    },
    mounted () {
      this.getTargets()
    },
    methods: {
      getTargetDevicesByTarget () {
        var self = this
        self.loadingTargetDevices = true
        targetdDevicesRespository.getTargetDevicesByTarget(self.parameter.targetId).then(response => {
          self.targetDevices = response.data.data
          self.loadingTargetDevices = false
          // self.parameter.targetDeviceId = null
        }).catch(err => {
          self.loadingTargetDevices = false
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      getTargets () {
        var self = this
        self.loadingTargets = true
        targetsRespository.getActivesByType('TA').then(response => {
          self.targets = response.data.data
          self.loadingTargets = false
        }).catch(err => {
          self.loadingTargets = false
          self.showErrorMessage = true
          self.errorMessage = err
        })
      },
      getHistoryListRangeDate () {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        var self = this
        if (self.parameter.targetDeviceId) {
          var parameters = Object.assign({}, this.parameter)
          parameters.endDate = moment(`${this.parameter.endDate} ${this.endTime}:00`).format()
          parameters.startDate = moment(`${this.parameter.startDate} ${this.startTime}:00`).format()

          var data = {
            data: parameters,
            page: page,
            pageSize: itemsPerPage,
            sortBy: sortBy,
            sortDesc: sortDesc,
          }
          self.graphTargetDeviceId = self.parameter.targetDeviceId
          self.loadingTankList = true
          tankRepository.getHistoryListRangeDate(data).then(response => {
            self.tankList = response.data.data
            self.totalTanks = response.data.totalRows
            self.loadingTankList = false
          }).catch(err => {
            self.loadingTankList = false
            self.showErrorMessage = true
            self.errorMessage = err
          })
        }
      },
      async downloadExcel () {
        if (this.parameter.targetDeviceId) {
          var parameters = Object.assign({}, this.parameter)
          parameters.endDate = moment(`${this.parameter.endDate} ${this.endTime}:00`).format()
          parameters.startDate = moment(`${this.parameter.startDate} ${this.startTime}:00`).format()

          var data = {
            data: parameters,
          }
          this.loadingExcel = true
          const response = await tankRepository.getHistoryListRangeDate(data)
          const columns = [
            { key: 'registerAt', title: 'Fecha', cell: 'A1', type: 'Datetime' },
            { key: 'currentLiters', title: 'Litros', cell: 'B1' },
            { key: 'currentGallons', title: 'Galones', cell: 'C1' },
          ]
          exportToExcel('MedicionesTanque', columns, response.data.data)
          this.loadingExcel = false
        }
      },
    },
  }
</script>

<style>
.bgTankReport{
  background-color: #023A66 !important;
}
</style>
